import React from "react";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <div>
      <h1> Oops, there is no recipe here</h1>
      <Link to="/">Return Home</Link>
    </div>
  );
}
